// DISMISS_FLAG
export const DISMISS_FLAG = 'DISMISS_FLAG' as const;

export const dismissFlag = (id: number) => ({ type: DISMISS_FLAG, payload: id });

export type FlagAction = ReturnType<typeof dismissFlag>;
